var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'breakdance-canvas-right-click-menu-item': true,
    'breakdance-canvas-right-click-menu-item-disabled': _vm.disabled
  },on:{"click":function($event){_vm.disabled ? () => {} : _vm.$emit('click', $event)}}},[_vm._t("default"),(_vm.shortcut)?_c('div',{staticClass:"breakdance-canvas-right-click-menu-item-shortcut"},[_vm._v(" "+_vm._s(_vm.isMac ? _vm.shortcut[0] : _vm.shortcut[1])+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }